import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Global } from "@/admin/AdminPartners";
import { Panel, Stat, inr, Empty } from "@/admin/ui";

export const AdminCommission = () => {
  const [d, setD] = useState(null);
  const load = useCallback(() => api.get("/admin/partners").then((r) => setD(r.data)).catch((e) => toast.error(errMsg(e))), []);
  useEffect(() => { load(); }, [load]);
  if (!d) return <p className="text-[#6B7F74]">Loading…</p>;
  const due = d.partners.reduce((s, p) => s + p.commission_total.due, 0);
  const settled = d.partners.reduce((s, p) => s + p.commission_total.settled, 0);
  const settle = (p) => window.confirm(`Mark ${inr(p.commission_total.due)} from ${p.name} as received?`) &&
    api.post(`/admin/partners/${p.staff_id}/commission/settle`).then(() => { toast.success("Marked as settled"); load(); }).catch((e) => toast.error(errMsg(e)));
  return (
    <div className="space-y-6" data-testid="admin-commission">
      <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
        <Stat label="Status" value={d.commission.enabled ? "On" : "Off"} hint={`default ${d.commission.pct}% per pickup`} tone={d.commission.enabled ? "green" : "grey"} testid="commission-status" />
        <Stat label="Due from partners" value={inr(due)} tone="coral" testid="commission-due-total" />
        <Stat label="Collected" value={inr(settled)} tone="green" testid="commission-settled-total" />
        <Stat label="Partners waived" value={d.partners.filter((p) => p.commission_waived).length} tone="ink" />
      </div>
      <Global key={JSON.stringify(d.commission)} cfg={d.commission} onSaved={load} />
      <Panel title="Partner ledger" sub="Per-partner % and waivers can be set in Profiles & Docs">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[620px] text-left text-sm" data-testid="commission-ledger">
            <thead className="text-xs uppercase text-[#6B7F74]"><tr>{["Partner", "Rate", "Due", "Settled", ""].map((h) => <th key={h} className="pb-2">{h}</th>)}</tr></thead>
            <tbody>{d.partners.map((p) => (
              <tr key={p.staff_id} className="border-t border-[#F0F2EC]">
                <td className="py-2"><b>{p.name}</b><br /><span className="text-xs text-[#6B7F74]">{p.mobile}</span></td>
                <td>{p.commission_waived ? "Waived" : `${p.commission_pct ?? d.commission.pct}%`}</td>
                <td className="font-bold text-[#E05C3A]">{inr(p.commission_total.due)}</td><td>{inr(p.commission_total.settled)}</td>
                <td className="text-right">{p.commission_total.due > 0 && <button onClick={() => settle(p)} className="h-8 rounded-full bg-[#2E9E6B] px-3 text-xs font-bold text-white" data-testid={`ledger-settle-${p.staff_id}`}>Mark received</button>}</td>
              </tr>))}</tbody>
          </table>
          {!d.partners.length && <Empty>No partners yet.</Empty>}
        </div>
      </Panel>
    </div>
  );
};
